export const trackPageView = pageUrl => {
    _hmt.push(['_trackPageview', pageUrl]);
};

export const trackEvent = (category, action, label, value) => {
    _hmt.push(['_trackEvent', category, action, label, value]);
};


// WEBPACK FOOTER //
// ./src/utils/libs/track.js